import * as React from "react";
import ReactDOM from "react-dom";
import {ILoader, ILoaderState} from "../common/common.models";
import styled, {keyframes} from "styled-components";

export const CheckoutLoaderContext = React.createContext<ILoader>(null!);

// Animazione pallini (loader7)
const load7 = keyframes`
    0%, 80%, 100% {
        box-shadow: 0 2.5em 0 -1.3em;
    }
    40% {
        box-shadow: 0 2.5em 0 0;
    }
`;

// Loader visuale
const StyledLoader = styled.div`
    color: #000;
    font-size: 10px;
    margin: 80px auto;
    width: 1em;
    height: 1em;
    border-radius: 50%;
    position: relative;
    text-indent: -9999em;
    animation: ${load7} 1.8s infinite ease-in-out;
    transform: translateZ(0);
    animation-delay: -0.16s;

    &::before,
    &::after {
        content: '';
        position: absolute;
        top: 0;
        width: 1em;
        height: 1em;
        border-radius: 50%;
        animation: ${load7} 1.8s infinite ease-in-out;
    }

    &::before {
        left: -1.5em;
        animation-delay: -0.32s;
    }

    &::after {
        left: 1.5em;
    }
`;

// Overlay a schermo intero
const FullscreenOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.85);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const CheckoutLoaderContextComponent = (props: any) => {
    const {children} = props;

    const [state, setState] = React.useState<ILoaderState>({
        show: false,
    });

    const show = () => {
        document.body.style.overflow = "hidden";
        setState({
            show: true
        });
    };

    const hide = () => {
        document.body.style.overflow = "initial";
        setState({
            show: false
        });
    };

    return (
        <CheckoutLoaderContext.Provider
            value={{
                show: show,
                hide: hide,
                state: state
            }}
        >
            {children}
            {state.show &&
                ReactDOM.createPortal(
                    <FullscreenOverlay>
                        <StyledLoader>Loading...</StyledLoader>
                    </FullscreenOverlay>,
                    document.body
                )
            }
        </CheckoutLoaderContext.Provider>
    );
};